import HestiaAPI        from './index';
import ky               from 'ky';
import Config           from '../config';
import { useUserStore } from '@/store/user';

const Service = {

  sendToSupport : async (tenantId, mailInfos) => {

    return await HestiaAPI.Mail.mail.sendToSupport(tenantId, mailInfos);
  },

  // NOTIFICATIONS
  async getNotifications(tenantId, searchParams) {

    return await HestiaAPI.Notification.notification.list(tenantId, {
      searchParams : { ...searchParams, category : 'commission' }
    }).json();
  },
  async getNotificationsUnread(tenantId) {

    return await HestiaAPI.Notification.notification.list(tenantId, {
      searchParams : { 'read:eq' : false, category : 'commission' }
    }).json();
  },
  async readNotification(tenantId, id) {

    return await HestiaAPI.Notification.notification.read(tenantId, id).json();
  },
  async readAllNotifications(tenantId) {

    return await HestiaAPI.Notification.notification.readAll(tenantId, {}, {
      searchParams : { category : 'commission' }
    }).json();
  },
  async unreadNotification(tenantId, id) {

    return await HestiaAPI.Notification.notification.unread(tenantId, id).json();
  },

  // GET SPECIFIC ITEM
  getUser     : async (tenantId, userId) => {

    return await HestiaAPI.User.user.get(tenantId, userId).json();
  },
  getProperty : async (tenantId, id) => {

    return await HestiaAPI.Property.property.get(tenantId, id).json();
  },
  getMandate  : async (tenantId, id) => {

    return await HestiaAPI.Mandate.mandate.get(tenantId, id).json();
  },

  getMandateCommissions : async (tenantId) => {

    return await HestiaAPI.Mandate.commission.get(tenantId).json();
  },
  getOffer              : async (tenantId, propertyId, id) => {

    return await HestiaAPI.Property.offer.get(tenantId, propertyId, id).json();
  },
  getAda                : async (tenantId, id) => {

    return await HestiaAPI.Apporteur.apporteur.get(tenantId, id).json();
  },
  getCommune            : async (tenantId, communeId) => {

    return await HestiaAPI.Geo.commune.get(tenantId, communeId).json();
  },
  getLead               : async (tenantId, id) => {

    return await HestiaAPI.Lead.source.get(tenantId, id).json();
  },

  // USER
  updateUser : async (tenantId, userId, user) => {

    return await HestiaAPI.User.user.update(tenantId, userId, user).json();
  },

  // USER COMMENTS
  getUserComment    : async (tenantId, userId) => {

    const comments = await HestiaAPI.User.comment.find(tenantId, {
      searchParams : {
        'type:eq'   : 'comms',
        'userId:eq' : userId
      }
    }).json();

    return comments.results[0];
  },
  createUserComment : async (tenantId, payload) => {

    return await HestiaAPI.User.comment.create(tenantId, {
      type : 'comms',
      ...payload
    }).json();
  },
  updateUserComment : async (tenantId, id, payload) => {

    return await HestiaAPI.User.comment.update(tenantId, id, payload).json();
  },
  deleteUserComment : async (tenantId, id) => {

    return await HestiaAPI.User.comment.delete(tenantId, id).json();
  },

  // BOOKMARKS
  getBookmarks   : async (tenantId, userId) => {

    return await HestiaAPI.Bookmark.bookmark.list(tenantId, { searchParams : { userId } }).json();
  },
  createBookmark : async (tenantId, bookmark) => {

    return await HestiaAPI.Bookmark.bookmark.create(tenantId, bookmark).json();
  },
  updateBookmark : async (tenantId, bookmarkId, bookmark) => {

    return await HestiaAPI.Bookmark.bookmark.update(tenantId, bookmarkId, bookmark).json();
  },
  deleteBookmark : async (tenantId, bookmarkId) => {

    return await HestiaAPI.Bookmark.bookmark.delete(tenantId, bookmarkId).json();
  },

  // CLASSEURS
  getClasseurs   : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.classeur.find(tenantId, { searchParams }).json();
  },
  getClasseur    : async (tenantId, classeurId) => {

    return await HestiaAPI.Commission.classeur.get(tenantId, classeurId).json();
  },
  createClasseur : async (tenantId, classeur) => {

    return await HestiaAPI.Commission.classeur.create(tenantId, classeur).json();
  },
  updateClasseur : async (tenantId, classeurId, classeur) => {

    return await HestiaAPI.Commission.classeur.update(tenantId, classeurId, classeur).json();
  },

  // FOLDERS
  getFolders                  : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.dossier.find(tenantId, { searchParams }).json();
  },
  getFoldersWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.dossier.find.paginate(tenantId, { searchParams });
  },
  getFolder                   : async (tenantId, folderId) => {

    return await HestiaAPI.Commission.dossier.get(tenantId, folderId).json();
  },
  createFolder                : async (tenantId, payload) => {

    return await HestiaAPI.Commission.dossier.create(tenantId, payload).json();
  },
  updateFolder                : async (tenantId, folderId, folder) => {

    return await HestiaAPI.Commission.dossier.update(tenantId, folderId, folder).json();
  },
  previewFolder               : async (tenantId, query) => {

    return await HestiaAPI.Commission.dossier.preview(tenantId, query).json();
  },
  generateDossierCover        : async (tenantId, dossierId) => {

    return await HestiaAPI.Commission.dossierCover.create(tenantId, dossierId).json();
  },
  updateHiddenFolder          : async (tenantId, folderId, hide) => {

    return await HestiaAPI.Commission.dossier.updateHidden(tenantId, folderId, hide).json();
  },

  // FOLDER DISPUTE
  getDisputes   : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.dispute.list(tenantId, { searchParams }).json();
  },
  createDispute : async (tenantId, folderId, description) => {

    return await HestiaAPI.Commission.dispute.create(tenantId, {
      dossierId   : folderId,
      description : description
    }).json();
  },
  closeDispute  : async (tenantId, disputeId, note) => {

    return await HestiaAPI.Commission.dispute.update(tenantId, disputeId, {
      resolved : {
        state : true,
        note  : note
      }
    }).json();
  },

  // FOLDER ACTORS AND INVOICES
  getActors                  : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.actor.find(tenantId, { searchParams }).json();
  },
  getActorsWithoutPagination : async (tenantId, { searchParams }) => {

    return await HestiaAPI.Commission.actor.find.paginate(tenantId, { searchParams });
  },
  createActor                : async (tenantId, actor) => {

    return await HestiaAPI.Commission.actor.create(tenantId, actor).json();
  },
  updateActor                : async (tenantId, actorId, actor) => {

    return await HestiaAPI.Commission.actor.update(tenantId, actorId, actor).json();
  },
  updateActorAgentValidation : async (tenantId, actorId, newStatus) => {

    return await HestiaAPI.Commission.actor.putAgentValidation(tenantId, actorId, newStatus).json();
  },
  deleteActor                : async (tenantId, actorId) => {

    return await HestiaAPI.Commission.actor.delete(tenantId, actorId).json();
  },

  // THIRD PARTIES INVOICES
  getActorsWithInvoices                         : async (tenantId, folderId) => {

    return await HestiaAPI.Commission.thirdPartyInvoice.findActorsByDossier(tenantId, folderId).json();
  },
  getActorInvoicePreview                        : async (tenantId, json) => {

    return await HestiaAPI.Commission.thirdPartyInvoice.preview(tenantId, json,
      { searchParams : { format : 'html' } }
    ).json();
  },
  getThirdPartyInvoice                          : async (tenantId, thirdPartyInvoiceId) => {

    return await HestiaAPI.Commission.thirdPartyInvoice.findById(tenantId, thirdPartyInvoiceId).json();
  },
  createThirdPartyInvoice                       : async (tenantId, json) => {

    return await HestiaAPI.Commission.thirdPartyInvoice.create(tenantId, json).json();
  },
  updateThirdPartyInvoice                       : async (tenantId, thirdPartyInvoiceId, thirdPartyInvoice) => {

    return await HestiaAPI.Commission.thirdPartyInvoice.update(tenantId, thirdPartyInvoiceId, thirdPartyInvoice).json();
  },
  resetThirdPartyInvoice                        : async (tenantId, thirdPartyInvoiceId) => {

    return await HestiaAPI.Commission.thirdPartyInvoice.reset(tenantId, thirdPartyInvoiceId);
  },
  getDossierThirdPartyInvoices                  : async (tenantId, dossierId, searchParams) => {

    return await HestiaAPI.Commission.thirdPartyInvoice.find(tenantId, {
      searchParams : {
        ...searchParams,
        'dossierId:eq' : dossierId
      }
    }).json();
  },
  getDossierThirdPartyInvoicesWithoutPagination : async (tenantId, dossierId, searchParams) => {

    return await HestiaAPI.Commission.thirdPartyInvoice.find.paginate(tenantId, {
      searchParams : {
        ...searchParams,
        'dossierId:eq' : dossierId
      }
    });
  },
  getThirdPartyInvoiceMailingTemplate           : async (tenantId, language) => {

    const searchParams = { language };

    return await HestiaAPI.Commission.thirdPartyInvoiceMailingTemplate.get(tenantId, {
      searchParams
    }).json();
  },
  getLinkMailingTemplate                        : async (tenantId, language, type) => {

    const searchParams = { language, type };

    return await HestiaAPI.Commission.linkMailingTemplate.get(tenantId, {
      searchParams
    }).json();
  },
  updateThirdPartyInvoiceMailingTemplate        : async (tenantId, json) => {

    return await HestiaAPI.Commission.thirdPartyInvoiceMailingTemplate.update(tenantId, json).json();
  },
  updateLinkMailingTemplate                     : async (tenantId, json) => {

    return await HestiaAPI.Commission.linkMailingTemplate.update(tenantId, json).json();
  },
  sendInvoiceByMail                             : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.thirdPartyInvoice.send(tenantId, searchParams);
  },

  // OTHER
  getPropertiesOffers  : async (tenantId, propertyId, searchParams) => {

    const response = await HestiaAPI.Property.offer.list(tenantId, {
      searchParams : {
        ...searchParams,
        'propertyId:eq' : propertyId
      }
    }).json();

    return response.results;
  },
  getAppointments      : async (tenantId, searchParams) => {

    return await HestiaAPI.Appointment.appointment.list(tenantId, { searchParams }).json();
  },
  getMandateProperties : async (tenantId, mandateId) => {

    const response = await HestiaAPI.Property.property.list(tenantId, {
      searchParams : {
        'mandates:contains' : mandateId
      }
    }).json();

    return response.results;
  },
  getDocumentFromS3    : async (tenantId, id) => {

    return await HestiaAPI.Document.document.url(tenantId, id).json();
  },
  getDashboardData     : async (tenantId, id) => {

    return await HestiaAPI.Commission.metric.dashboard(tenantId, id).json();
  },

  // FOLDER TASKS
  getTasks                  : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.task.find(tenantId, { searchParams }).json();
  },
  getTasksWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.task.find.paginate(tenantId, { searchParams });
  },
  createTask                : async (tenantId, payload) => {

    return await HestiaAPI.Commission.task.create(tenantId, payload).json();
  },
  updateTask                : async (tenantId, taskId, task) => {

    return await HestiaAPI.Commission.task.update(tenantId, taskId, task).json();
  },
  deleteTask                : async (tenantId, taskId) => {

    return await HestiaAPI.Commission.task.delete(tenantId, taskId).json();
  },

  // FOLDER TASK REMINDERS
  getReminders   : async (tenantId, taskId) => {

    return await HestiaAPI.Commission.reminder.list.paginate(tenantId, {
      searchParams : {
        orderBy     : 'date',
        'taskId:eq' : taskId
      }
    });
  },
  createReminder : async (tenantId, payload) => {

    return await HestiaAPI.Commission.reminder.create(tenantId, payload).json();
  },
  updateReminder : async (tenantId, reminderId, reminder) => {

    return await HestiaAPI.Commission.reminder.update(tenantId, reminderId, reminder).json();
  },
  deleteReminder : async (tenantId, reminderId) => {

    return await HestiaAPI.Commission.reminder.delete(tenantId, reminderId).json();
  },

  // FOLDER DOCUMENTS
  getDocuments          : async (tenantId, dossierId) => {

    return await HestiaAPI.Commission.netexplorer.listFiles(tenantId, dossierId, {
      folderSlug : `/commissions/${ dossierId }`
    }).json();
  },
  documentsCreateFolder : async (tenantId, dossierId, slug) => {

    return await HestiaAPI.Commission.netexplorer.createFolder(tenantId, dossierId, slug).json();
  },
  addDocument           : (tenantId, dossierId, file, slug, customName) => {

    const formData = new FormData();
    if (customName) {
      formData.append('file', file, customName);
    }

    else {
      formData.append('file', file);
    }

    formData.append('folderSlug', `/commissions/${ slug }`);

    const store = useUserStore();
    return ky.post(`${Config.baseURL}/tenant/${tenantId}/commission/dossier/${dossierId}/file`, {
      body    : formData,
      headers : {
        'Authorization' : `Bearer ${store.token}`
      }
    }).json();
  },
  updateDocument        : async (tenantId, dossierId, id, payload) => {

    return await HestiaAPI.Commission.netexplorer.updateFile(tenantId, dossierId, id, payload).json();
  },
  deleteDocument        : async (tenantId, dossierId, payload) => {

    return await HestiaAPI.Commission.netexplorer.deleteFile(tenantId, dossierId, payload).json();
  },
  uploadLink            : async (tenantId, dossierId, folderId) => {

    return await HestiaAPI.Commission.netexplorer.createUploadLink(tenantId, dossierId, { folderId }).json();
  },
  getFileURL            : async (tenantId, dossierId, id) => {

    return await HestiaAPI.Commission.netexplorer.downloadFile(tenantId, dossierId, id).json();
  },
  getFilePreview        : async (tenantId, dossierId, id) => {

    return await HestiaAPI.Commission.netexplorer.getPreview(tenantId, dossierId, id).blob();
  },
  sendUploadLink        : async (tenantId, dossierId, payload) => {

    return await HestiaAPI.Commission.netexplorer.sendUploadLink(tenantId, dossierId, payload).json();
  },

  sendDownloadLink        : async (tenantId, dossierId, payload) => {

    return await HestiaAPI.Commission.netexplorer.sendDownloadLink(tenantId, dossierId, payload).json();
  },
  downloadDocumentsFolder : async (tenantId, dossierId, id, payload) => {

    return await HestiaAPI.Commission.netexplorer.downloadFolder(tenantId, dossierId, id, { searchParams : payload }).json();
  },

  // FOLDER COMMISSIONS
  calculateCommissions : async (tenantId, dossierId) => {

    return await HestiaAPI.Commission.commissionData.calculate(tenantId, {}, {
      searchParams : {
        dossierId : dossierId
      }
    }).json();
  },

  formatCalculationData                 : async (tenantId, dossierId) => {

    return await HestiaAPI.Commission.commissionData.formatCalculationData(tenantId, {
      searchParams : {
        dossierId : dossierId
      }
    }).json();
  },
  getCommissions                        : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.commissionData.find(tenantId, {
      searchParams : {
        ...searchParams,
        'deleted:eq' : false
      }
    }).json();
  },
  getCommissionsWithoutPagination       : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.commissionData.find.paginate(tenantId, {
      searchParams : {
        ...searchParams,
        'deleted:eq' : false
      }
    });
  },
  getCommissionsConflicts               : async (tenantId, dossierId) => {

    return await HestiaAPI.Commission.dossier.conflicts(tenantId, dossierId).json();
  },
  getCommissionsRules                   : async (tenantId, dossierId) => {

    const commissioningRules = await HestiaAPI.Commission.commissioningRules.find(tenantId, {
      searchParams : {
        perPage        : 1000,
        'dossierId:eq' : dossierId
      }
    }).json();

    return commissioningRules.results;
  },
  getManualCommissionsWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.manualCommissionData.find.paginate(tenantId, { searchParams : searchParams });
  },

  createManualCommission : async (tenantId, commission) => {

    return await HestiaAPI.Commission.manualCommissionData.create(tenantId, commission).json();
  },
  updateManualCommission : async (tenantId, commissionId, commission) => {

    return await HestiaAPI.Commission.manualCommissionData.update(tenantId, commissionId, commission).json();
  },

  deleteManualCommission                  : async (tenantId, commissionId) => {

    return await HestiaAPI.Commission.manualCommissionData.delete(tenantId, commissionId).json();
  },
  getCommissionTemplatesWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.commissionTemplate.find.paginate(tenantId, { searchParams });
  },
  getCommissionScales                     : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.commissionScale.find.paginate(tenantId, { searchParams });
  },
  createCommissionScales                  : async (tenantId, commissionScales) => {

    return await HestiaAPI.Commission.commissionScale.create(tenantId, commissionScales).json();
  },
  updateCommissionScales                  : async (tenantId, commissionScaleId, commissionScales) => {

    return await HestiaAPI.Commission.commissionScale.update(tenantId, commissionScaleId, commissionScales).json();
  },
  deleteCommissionScale                   : async (tenantId, commissionScaleId) => {

    return await HestiaAPI.Commission.commissionScale.delete(tenantId, commissionScaleId).json();
  },

  getCommissioningRule : async (tenantId, ruleType, dossierId) => {

    return await HestiaAPI.Commission.commissioningRules.get(tenantId, ruleType, dossierId).json();
  },

  updateCommissioningRule : async (tenantId, ruleType, dossierId, payload) => {

    return await HestiaAPI.Commission.commissioningRules.set(tenantId, dossierId, ruleType, payload);
  },
  updateCommissionData    : async (tenantId, commissionId, payload) => {

    return await HestiaAPI.Commission.commissionData.update(tenantId, commissionId, payload);
  },
  updateRollings          : async (tenantId, dossierId) => {

    return await HestiaAPI.Commission.dossier.updateRollings(tenantId, dossierId).json();
  },

  dropCalculatedCommissions : async (tenantId, dossierId) => {

    return await HestiaAPI.Commission.dossier.dropCalculatedCommissions(tenantId, dossierId).json();
  },

  // PROFORMAS

  getProformas : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.proforma.find(tenantId, { searchParams }).json();
  },

  getProformasWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.proforma.find.paginate(tenantId, { searchParams });
  },

  getProforma                   : async (tenantId, id) => {

    return await HestiaAPI.Commission.proforma.get(tenantId, id).json();
  },
  getProformaTemplate           : async (tenantId, type, language = 'fr') => {

    return await HestiaAPI.Commission.proformaTemplate.get(tenantId, type, language).json();
  },
  updateProformaTemplate        : async (tenantId, type, language, json) => {

    return await HestiaAPI.Commission.proformaTemplate.update(tenantId, type, language, json).json();
  },
  updateProforma                : async (tenantId, proformaId, proforma) => {

    return await HestiaAPI.Commission.proforma.update(tenantId, proformaId, proforma).json();
  },
  async addInvoice(tenantId, file, proformaIds) {

    const formData = new FormData();
    formData.append('file', file);
    for (const proformaId of proformaIds) {

      formData.append('proformaIds', proformaId);
    }

    const store = useUserStore();
    return await ky.post(`${Config.baseURL}/tenant/${tenantId}/commission/invoice`, {
      body    : formData,
      headers : {
        'Authorization' : `Bearer ${store.token}`
      }
    }).json();
  },
  async getInvoice(tenantId, invoiceId) {

    return await HestiaAPI.Commission.invoice.get(tenantId, invoiceId).json();
  },
  async updateInvoice(tenantId, invoiceId, invoice) {

    return await HestiaAPI.Commission.invoice.update(tenantId, invoiceId, invoice).json();
  },

  // NOTARIES
  getNotaries           : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.notary.list(tenantId, { searchParams }).json();
  },
  getNotary             : async (tenantId, id) => {

    return await HestiaAPI.Commission.notary.get(tenantId, id).json();
  },
  createNotary          : async (tenantId, payload) => {

    return await HestiaAPI.Commission.notary.create(tenantId, payload).json();
  },
  updateNotary          : async (tenantId, notaryId, notary) => {

    return await HestiaAPI.Commission.notary.update(tenantId, notaryId, notary).json();
  },
  deleteNotary          : async (tenantId, notaryId) => {

    return await HestiaAPI.Commission.notary.delete(tenantId, notaryId).json();
  },
  getInvoiceTemplate    : async (tenantId, type, language) => {

    const searchParams = { type, language };

    return await HestiaAPI.Commission.thirdPartyInvoiceTemplate.get(tenantId, {
      searchParams
    }).json();
  },
  createInvoiceTemplate : async (tenantId, name, template, type, language) => {

    const body = { name, template, type, language };

    return await HestiaAPI.Commission.thirdPartyInvoiceTemplate.create(tenantId, body).json();
  },
  updateInvoiceTemplate : async (tenantId, json) => {

    return await HestiaAPI.Commission.thirdPartyInvoiceTemplate.update(tenantId, json).json();
  },

  // CLERKS
  getClerks   : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.notaryClerk.list(tenantId, { searchParams }).json();
  },
  getClerk    : async (tenantId, id) => {

    return await HestiaAPI.Commission.notaryClerk.get(tenantId, id).json();
  },
  createClerk : async (tenantId, payload) => {

    return await HestiaAPI.Commission.notaryClerk.create(tenantId, payload).json();
  },
  updateClerk : async (tenantId, clerkId, clerk) => {

    return await HestiaAPI.Commission.notaryClerk.update(tenantId, clerkId, clerk).json();
  },
  deleteClerk : async (tenantId, clerkId) => {

    return await HestiaAPI.Commission.notaryClerk.delete(tenantId, clerkId).json();
  },

  // PARTNERS
  getPartner      : async (tenantId, id) => {

    return await HestiaAPI.Commission.partner.get(tenantId, id).json();
  },
  getPartners     : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.partner.find(tenantId, { searchParams }).json();
  },
  createPartner   : async (tenantId, partner) => {

    return await HestiaAPI.Commission.partner.create(tenantId, partner).json();
  },
  updatePartner   : async (tenantId, partnerId, partner) => {

    return await HestiaAPI.Commission.partner.update(tenantId, partnerId, partner).json();
  },
  getAppliedLevel : async (tenantId, partnerId, data) => {

    return await HestiaAPI.Commission.partner.getAppliedLevel(tenantId, partnerId, data).json();
  },
  // PARTNER SCALE
  getPartnerScales   : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.partnerScale.find(tenantId, { searchParams }).json();
  },
  createPartnerScale : async (tenantId, partnerScale) => {

    return await HestiaAPI.Commission.partnerScale.create(tenantId, partnerScale).json();
  },
  updatePartnerScale : async (tenantId, partnerScaleId, partnerScale) => {

    return await HestiaAPI.Commission.partnerScale.update(tenantId, partnerScaleId, partnerScale).json();
  },

  // TASK TEMPLATES
  getTaskTemplates   : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.taskTemplate.find(tenantId, {
      searchParams : {
        ...searchParams,
        'deleted:eq' : false
      }
    }).json();
  },
  getTaskTemplate    : async (tenantId, templateId) => {

    return await HestiaAPI.Commission.taskTemplate.get(tenantId, templateId).json();
  },
  createTaskTemplate : async (tenantId, template) => {

    return await HestiaAPI.Commission.taskTemplate.create(tenantId, template).json();
  },
  updateTaskTemplate : async (tenantId, templateId, template) => {

    return await HestiaAPI.Commission.taskTemplate.update(tenantId, templateId, template).json();
  },
  deleteTaskTemplate : async (tenantId, templateId) => {

    return await HestiaAPI.Commission.taskTemplate.delete(tenantId, templateId).json();
  },

  // USERS RELATIONS
  getRelations                  : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.relation.find(tenantId, { searchParams }).json();
  },
  getRelationsWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.relation.find.paginate(tenantId, { searchParams });
  },
  createRelation                : async (tenantId, relation) => {

    return await HestiaAPI.Commission.relation.create(tenantId, relation).json();
  },
  updateRelation                : async (tenantId, relationId, relation) => {

    return await HestiaAPI.Commission.relation.update(tenantId, relationId, relation).json();
  },
  deleteRelation                : async (tenantId, relationId) => {

    return await HestiaAPI.Commission.relation.delete(tenantId, relationId).json();
  },

  // EXCEPTIONS
  getExceptions       : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.exception.find(tenantId, { searchParams }).json();
  },
  createException     : async (tenantId, exception) => {

    return await HestiaAPI.Commission.exception.create(tenantId, exception).json();
  },
  updateException     : async (tenantId, exceptionId, exception) => {

    return await HestiaAPI.Commission.exception.update(tenantId, exceptionId, exception).json();
  },
  deleteException     : async (tenantId, exceptionId) => {

    return await HestiaAPI.Commission.exception.delete(tenantId, exceptionId).json();
  },
  getFolderExceptions : async (tenantId, folderId) => {

    return await HestiaAPI.Commission.exception.findExceptionsByDossier(tenantId, folderId).json();
  },

  // OVERRIDES
  getOverridesWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.userOverride.find.paginate(tenantId, { searchParams });
  },
  createOverride                : async (tenantId, override) => {

    return await HestiaAPI.Commission.userOverride.create(tenantId, override).json();
  },
  updateOverride                : async (tenantId, overrideId, override) => {

    return await HestiaAPI.Commission.userOverride.update(tenantId, overrideId, override).json();
  },
  deleteOverride                : async (tenantId, overrideId) => {

    return await HestiaAPI.Commission.userOverride.delete(tenantId, overrideId).json();
  },

  // SALES HISTORY
  getMovementsUnpaginate : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.movement.find.paginate(tenantId, { searchParams });
  },

  // SALE TYPES
  getSaleTypes : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.saleType.find.paginate(tenantId, { searchParams });
  },
  getSaleType  : async (tenantId, id) => {

    return await HestiaAPI.Commission.saleType.get(tenantId, id).json();
  },

  // BANK ACCOUNTS
  getBankAccount                   : async (tenantId, id) => {

    return await HestiaAPI.Commission.bankAccount.get(tenantId, id).json();
  },
  getBankAccounts                  : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.bankAccount.find(tenantId, { searchParams }).json();
  },
  getBankAccountsWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.bankAccount.find.paginate(tenantId, { searchParams });
  },
  createBankAccount                : async (tenantId, bankAccount) => {

    return await HestiaAPI.Commission.bankAccount.create(tenantId, bankAccount).json();
  },
  updateBankAccount                : async (tenantId, bankAccountId, bankAccount) => {

    return await HestiaAPI.Commission.bankAccount.update(tenantId, bankAccountId, bankAccount).json();
  },
  deleteBankAccount                : async (tenantId, bankAccountId) => {

    return await HestiaAPI.Commission.bankAccount.delete(tenantId, bankAccountId).json();
  },

  // VEFA
  getVEFAContract            : async (tenantId, id) => {

    return await HestiaAPI.Commercialisation.mandate.get(tenantId, id).json();
  },
  getVEFAProgram             : async (tenantId, id) => {

    return await HestiaAPI.Commercialisation.program.get(tenantId, id).json();
  },
  getVEFAPrograms            : async (tenantId, mandateId) => {

    return await HestiaAPI.Commercialisation.program.list(tenantId, {
      searchParams : {
        perPage        : 1000,
        'mandateId:eq' : mandateId
      }
    }).json();
  },
  getVEFALots                : async (tenantId, programId) => {

    return await HestiaAPI.Commercialisation.lot.list(tenantId, {
      searchParams : {
        perPage        : 1000,
        'programId:eq' : programId
      }
    }).json();
  },
  getVEFALot                 : async (tenantId, id) => {

    return await HestiaAPI.Commercialisation.lot.get(tenantId, id).json();
  },
  getVEFABookingsByLot       : async (tenantId, lotId) => {

    return await HestiaAPI.Commercialisation.booking.list(tenantId, {
      searchParams : {
        'lotId:eq' : lotId
      }
    }).json();
  },
  getVEFABooking             : async (tenantId, bookingId) => {

    return await HestiaAPI.Commercialisation.booking.get(tenantId, bookingId).json();
  },
  getVEFABookings            : async (tenantId, searchParams) => {

    return await HestiaAPI.Commercialisation.booking.list(tenantId, { searchParams }).json();
  },
  getVEFADeveloper           : async (tenantId, developerId) => {

    return await HestiaAPI.Commercialisation.developer.get(tenantId, developerId).json();
  },
  getDossierCoverTemplate    : async (tenantId) => {

    return await HestiaAPI.Commission.dossierCoverTemplate.get(tenantId).json();
  },
  createDossierCoverTemplate : async (tenantId, dossierCoverTemplate) => {

    return await HestiaAPI.Commission.dossierCoverTemplate.create(tenantId, { template : dossierCoverTemplate }).json();
  },
  updateDossierCoverTemplate : async (tenantId, dossierCoverTemplate) => {

    return await HestiaAPI.Commission.dossierCoverTemplate.update(tenantId, dossierCoverTemplate).json();
  },

  getContract : async (tenantId, id) => {

    return await HestiaAPI.Commission.contract.get(tenantId, id, {}).json();
  },

  getContractsWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.contract.find.paginate(tenantId, { searchParams });
  },

  applyContract : async (tenantId, payload) => {

    return await HestiaAPI.Commission.contract.apply(tenantId, payload).json();
  },

  getPartnerCommissionsWithoutPagination : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.partnerCommissionData.find.paginate(tenantId, { searchParams : searchParams });
  },

  updatePartnerCommission : async (tenantId, commissionId, commission) => {

    return await HestiaAPI.Commission.partnerCommissionData.update(tenantId, commissionId, commission).json();
  },

  // CLIENTS
  getClients : async (tenantId, search) => {

    return await HestiaAPI.Client.client.search(tenantId, search).json();
  },
  getClient  : async (tenantId, id) => {

    return await HestiaAPI.Client.client.get(tenantId, id).json();
  },

  // COMPANIES
  getCompanies : async (tenantId, search) => {

    return await HestiaAPI.Company.company.search(tenantId, search).json();
  },
  getCompany   : async (tenantId, id) => {

    return await HestiaAPI.Company.company.get(tenantId, id).json();
  },

  getCancellingReasons : async (tenantId, searchParams) => {

    return await HestiaAPI.Commission.cancellingReason.find.paginate(tenantId, { searchParams });
  }
};

//CACHING

const useCache = true;

let cacheData = {};
let cacheTimeout = {};

const cachedService = cache(Service);

function cache(service) {

  if (!useCache) {
    return service;
  }

  const cached = {};

  Object.keys(service).forEach(key => {

    cached[key] = async (...args) => {

      if (['create', 'update', 'delete', 'refresh', 'add', 'drop', 'calculate', 'send', 'move', 'download', 'close', 'read', 'apply'].find((str) => key.includes(str))) {
        // Reset all caching before create, update or delete is done
        cacheData = {};
        Object.keys(cacheTimeout).forEach(key => clearTimeout(cacheTimeout[key]));
        cacheTimeout = {};
      }

      if (cacheData[key + JSON.stringify(args)]) {
        return cacheData[key + JSON.stringify(args)];
      }

      const response = await cached[key].original(...args);

      cacheData[key + JSON.stringify(args)] = response;

      cacheTimeout[key + JSON.stringify(args)] = setTimeout(() => {

        delete cacheData[key + JSON.stringify(args)];
      }, 1000 * 60);

      return response;
    };

    cached[key].original = service[key];
  });

  return cached;
}

export default cachedService;
